import gql from "graphql-tag";

export const GET_STEP_DETAILS = gql`
  query ($step_id: Int!) {
    getFieldsByStepId(step_id: $step_id) {
      field_id
      name
      field_unit
      field_info
      field_type
      field_input_type
      keys
      formula_inputs
      field_data_type
      formula
      step_id {
        step_id
        name
      }
      data_reference
      is_override_enabled
      is_optional
      field_step_index
      renderer
      is_premium
      technology_id {
        technology_id
        name
        description
      }
      step_type_id {
        step_type_id
        name
      }
    }
  }
`;
export const GET_CLIENT_MACHINE = gql`
  query ($technology_id: Int!) {
    getClientMachineByTechnology(technology_id: $technology_id) {
      machine_id
      name
    }
  }
`;

export const GET_MACHINE_BY_ID = gql`
  query($id: Int!) {
    getMachineById(id: $id) {
      machine_id
      name
      image_url
      step_time
      cooldown_time
      consumables
      
    }
  }
`;


export const GET_MACHINE_NAME_BY_ID = gql`
  query($machine_id: Int!) {
    getMachineNameById(machine_id: $machine_id) {
      name
    }
  }
`;
export const GET_MATERIAL_NAME_BY_ID = gql`
  query($material_id: Int!) {
    getMaterialNameById(material_id: $material_id){
      name
    }
  }
`;

// Full material details (including external link)
export const GET_MATERIAL_DETAILS = gql`
  query ($material_id: Int!) {
    getMaterialDetailWithPrices(material_id: $material_id) {
      data {
        material_id {
          link
        }
      }
    }
  }
`;

export const GET_PARAMERTER_NAME_BY_ID = gql`
  query($paremeter_id: Int!){
    getClientParemeterNameById(paremeter_id: $paremeter_id)
  }
`

export const GET_CLIENT_MATERIAL = gql`
  query ($machine_id: Int!, $group_id: Int!) {
    getClientMaterialByMachineId(machine_id: $machine_id, group_id: $group_id) {
      name
      material_id
    }
  }
`;

// Batch queries for multiple scenarios
export const GET_MACHINES_BY_IDS = gql`
  query($machine_ids: [Int!]!) {
    getMachinesByIds(machine_ids: $machine_ids) {
      machine_id
      name
      image_url
      step_time
      cooldown_time
      consumables
    }
  }
`;

export const GET_MATERIALS_DETAIL_WITH_PRICES_BY_IDS = gql`
  query($material_ids: [Int!]!) {
    getMaterialsDetailWithPricesByIds(material_ids: $material_ids) {
      data {
        material_id {
          material_id
          link
        }
      }
    }
  }
`;

export const GET_MATERIAL_NAMES_BY_IDS = gql`
  query($material_ids: [Int!]!) {
    getMaterialNamesByIds(material_ids: $material_ids) {
      material_id
      name
    }
  }
`;

export const GET_CLIENT_PAREMETER_NAMES_BY_IDS = gql`
  query($paremeter_ids: [Int!]!) {
    getClientParemeterNamesByIds(paremeter_ids: $paremeter_ids) {
      paremeter_id
      name
    }
  }
`;
